import { useState, useEffect } from "react";
import casinoService from "../services/casinoService";

export const useGameCounts = () => {
  const [counts, setCounts] = useState({
    slots: 0,
    table_games: 0,
    live_casino: 0,
    instant: 0,
    jackpots: 0,
    new: 0,
    popular: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchGameCounts = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // /games/categories returns authoritative counts per category from the
        // DB ({ key, name, count }). The previous implementation used
        // getGames({ limit: 1 }) and read array lengths — which capped every
        // category at 1, so the sidebar saw count: 1 across the board and
        // hid all of them.
        const categories = await casinoService.getGameCategories();
        if (!mounted) return;

        const next = {
          slots: 0,
          table_games: 0,
          live_casino: 0,
          instant: 0,
          jackpots: 0,
          new: 0,
          popular: 0,
        };
        for (const c of Array.isArray(categories) ? categories : []) {
          if (c?.key && typeof c.count === "number" && c.key in next) {
            next[c.key] = c.count;
          }
        }
        setCounts(next);
      } catch (e) {
        if (mounted) setError("Failed to load game counts");
      } finally {
        if (mounted) setIsLoading(false);
      }
    };

    fetchGameCounts();
    return () => {
      mounted = false;
    };
  }, []);

  return { counts, isLoading, error };
};
